import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useInstallForm } from "./hooks/useInstallForm";
import Wizard from "./components/Wizard";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";

const InstallView = () => {
  const [params] = useSearchParams();
  const id = params.get("id");

  const {
    methods,
    loadFromStorage,
    loadFromApi,
    saveToStorage,
    hasUnsavedChanges,
  } = useInstallForm();
  const { t } = useTranslation();

  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    if (id) {
      loadFromApi(id);
    } else {
      loadFromStorage();
    }
  }, [id]);

  useEffect(() => {
    const subscription = methods.watch(() => {
      saveToStorage();
    });
    return () => subscription.unsubscribe();
  }, [methods]);

  useEffect(() => {
    if (hasUnsavedChanges) {
    }
  }, [hasUnsavedChanges]);

  return (
    <div className="h-full overflow-auto bg-gray-100 w-full p-4">
      {hasUnsavedChanges ? (
        <>
          <Button onClick={() => setShowWizard(true)} variant={"contained"}>
            {t("resumeLastInstallation")}
          </Button>
          <Button onClick={() => setShowWizard(true)} variant={"contained"}>
            {t("startInstallation")}
          </Button>
        </>
      ) : (
        <>
          <Button onClick={() => setShowWizard(true)} variant={"contained"}>
            {t("startInstallation")}
          </Button>
        </>
      )}
      <Wizard methods={methods} />
    </div>
  );
};

export default InstallView;
